module.exports = __webpack_public_path__ + "static/media/crown_326.a560c9cd.png";